import { useEffect, useState } from 'react';
import { useUserTermsConfirmed, useUserPlayResponsiblyConfirmed } from '@/shared/providers/user-provider/use-user';
import { useBrandTheme } from '@/shared/hooks/useBrandTheme';

const TERMS_KEY = 'termsConfirmed';
const PLAY_RESPONSIBLY_KEY = 'playResponsiblyConfirmed';

export const useLoginConfirmationFlags = () => {
  const termsConfirmedUser = useUserTermsConfirmed();
  const playResponsiblyConfirmedUser = useUserPlayResponsiblyConfirmed();
  const { isPh, isPh2 } = useBrandTheme();
  const isPhOnly = isPh && !isPh2;
  const [isClient, setIsClient] = useState(false);
  const [localFlags, setLocalFlags] = useState<{ terms: boolean; playResponsibly: boolean }>({
    terms: false,
    playResponsibly: false,
  });

  useEffect(() => {
    setLocalFlags({
      terms: Boolean(sessionStorage.getItem(TERMS_KEY)),
      playResponsibly: Boolean(sessionStorage.getItem(PLAY_RESPONSIBLY_KEY)),
    });
    setIsClient(true);
  }, []);

  const termsConfirmed = Boolean(termsConfirmedUser) || localFlags.terms;
  const playResponsiblyConfirmed = Boolean(playResponsiblyConfirmedUser) || localFlags.playResponsibly;

  const confirmTerms = () => {
    sessionStorage.setItem(TERMS_KEY, 'true');
    setLocalFlags((prev) => ({ ...prev, terms: true }));
  };

  const confirmPlayResponsibly = () => {
    sessionStorage.setItem(PLAY_RESPONSIBLY_KEY, 'true');
    setLocalFlags((prev) => ({ ...prev, playResponsibly: true }));
  };

  return {
    isClient,
    isPhOnly,
    termsConfirmed,
    playResponsiblyConfirmed,
    confirmTerms,
    confirmPlayResponsibly,
  };
};

export const useIsLoginConfirmationDone = () => {
  const { isClient, isPhOnly, termsConfirmed, playResponsiblyConfirmed } = useLoginConfirmationFlags();

  if (!isPhOnly) {
    return true;
  }

  if (!isClient) {
    return false;
  }

  return termsConfirmed && playResponsiblyConfirmed;
};
